module.exports = __webpack_public_path__ + "static/media/icon-plus.24b1150e.svg";